import * as React from "react";
import { useMemo } from "react";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
import { Spinner } from "components/common";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { DEFAULT_FIELDS } from "data-lake/preview/storage-types/external/Constants";
import PreviewLayoutContext from "../../../contexts/PreviewLayoutContext";
const FieldSelectInfo = ({ isLoadingFields, tableId = void 0 }) => {
  if (isLoadingFields) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading field types" });
  }
  if (!tableId) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "Please ", /* @__PURE__ */ React.createElement("b", null, "select a table"), " in the search bar above or in the table list on the left side, before choosing fields for this widget.");
  }
  return null;
};
const WidgetEditInfo = () => /* @__PURE__ */ React.createElement(Alert, null, "The fields shown above come from the schema of the selected Security Lake table and vary depending on the data source. See ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.DATA_LAKE, text: "dcocumentation" }), ".");
const PreviewLayoutProvider = ({ children }) => {
  const { isLoading: isLoadingFields } = useFieldTypes();
  const { dataLakeFieldsFetchQuery } = useSelectedDataLake();
  const contextValue = useMemo(
    () => ({
      widgetEdit: {
        fieldSelectInfo: /* @__PURE__ */ React.createElement(FieldSelectInfo, { isLoadingFields, tableId: dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId }),
        formInfo: /* @__PURE__ */ React.createElement(WidgetEditInfo, null),
        showFieldSelect: !isLoadingFields && !!(dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId),
        fieldsCreationAllowed: false
      },
      defaultFields: DEFAULT_FIELDS,
      timestampField: "time_dt"
    }),
    [dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId, isLoadingFields]
  );
  return /* @__PURE__ */ React.createElement(PreviewLayoutContext.Provider, { value: contextValue }, children);
};
export default PreviewLayoutProvider;
